import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";

export default function Layout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [loc.pathname]);
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <div className="relative min-h-screen bg-[#060f1e] text-[#f7f5f0] grain">
      <Header />
      <main className="relative z-10 pt-20 lg:pt-24">
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </div>
  );
}
